import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { SectionEyebrow } from '../SectionEyebrow';
const Diagram: React.FC = () => <div className="relative aspect-square max-w-[480px] w-full mx-auto" data-id="element-434">
    <svg viewBox="0 0 400 400" className="w-full h-full" data-id="element-435">
      <defs data-id="element-436">
        <radialGradient id="centerGlow" cx="50%" cy="50%" data-id="element-437">
          <stop offset="0%" stopColor="#D4AF7A" stopOpacity="0.55" data-id="element-438" />
          <stop offset="100%" stopColor="#D4AF7A" stopOpacity="0" data-id="element-439" />
        </radialGradient>
        <linearGradient id="trailGrad" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-440">
          <stop offset="0%" stopColor="#D4AF7A" stopOpacity="0" data-id="element-441" />
          <stop offset="100%" stopColor="#D4AF7A" stopOpacity="0.6" data-id="element-442" />
        </linearGradient>
      </defs>
      {/* Glow center */}
      <circle cx="200" cy="200" r="170" fill="url(#centerGlow)" data-id="element-443" />
      {/* Outer rings */}
      <circle cx="200" cy="200" r="140" fill="none" stroke="rgba(212,175,122,0.2)" strokeWidth="1" data-id="element-444" />
      <circle cx="200" cy="200" r="100" fill="none" stroke="rgba(212,175,122,0.3)" strokeWidth="1" data-id="element-445" />
      <circle cx="200" cy="200" r="60" fill="none" stroke="rgba(212,175,122,0.5)" strokeWidth="1" data-id="element-446" />

      {/* Scattered pieces converging - more pieces */}
      {Array.from({
      length: 14
    }).map((_, i) => {
      const angle = i / 14 * Math.PI * 2;
      const startDist = 180 + i % 3 * 12;
      const endDist = 60;
      const startX = 200 + Math.cos(angle) * startDist;
      const startY = 200 + Math.sin(angle) * startDist;
      const endX = 200 + Math.cos(angle) * endDist;
      const endY = 200 + Math.sin(angle) * endDist;
      return <g key={i} data-id="element-447">
            <motion.line x1={startX} y1={startY} x2={endX} y2={endY} stroke="rgba(212,175,122,0.45)" strokeWidth="0.6" strokeDasharray="2 5" initial={{
          pathLength: 0,
          opacity: 0
        }} whileInView={{
          pathLength: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 2.5,
          delay: i * 0.08
        }} data-id="element-448" />
            <motion.circle r={2.5 + i % 3} fill="#D4AF7A" initial={{
          cx: startX,
          cy: startY,
          opacity: 0
        }} whileInView={{
          cx: endX,
          cy: endY,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 3,
          delay: i * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} style={{
          filter: 'drop-shadow(0 0 4px rgba(212,175,122,0.6))'
        }} data-id="element-449" />
          </g>;
    })}

      {/* Center sun */}
      <motion.circle cx="200" cy="200" r="16" fill="#D4AF7A" initial={{
      scale: 0
    }} whileInView={{
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: 1.5,
      duration: 1,
      ease: [0.22, 1, 0.36, 1]
    }} style={{
      transformOrigin: '200px 200px',
      filter: 'drop-shadow(0 0 12px rgba(212,175,122,0.9))'
    }} data-id="element-450" />
      <circle cx="200" cy="200" r="26" fill="none" stroke="#D4AF7A" strokeOpacity="0.4" strokeWidth="1" data-id="element-451" />
    </svg>
  </div>;
export const WhyDifferent: React.FC = () => <section className="relative bg-navy-deep py-28 lg:py-44 overflow-hidden" data-id="element-452">
    <div className="absolute inset-0" style={{
    background: 'radial-gradient(ellipse at 70% 50%, rgba(212,175,122,0.1), transparent 60%)'
  }} data-id="element-453" />

    <div className="relative max-w-6xl mx-auto px-6 lg:px-8" data-id="element-454">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-455">
        <Reveal data-id="element-456">
          <SectionEyebrow data-id="element-457">La diferencia</SectionEyebrow>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl text-ivory leading-[1.05] mb-8 text-balance" style={{
          fontWeight: 300
        }} data-id="element-458">
            No es solo motivación.
            <br data-id="element-459" />
            <span className="italic gold-text" style={{
            fontWeight: 400
          }} data-id="element-460">
              Es integración.
            </span>
          </h2>
          <div className="space-y-5 text-ivory/70 leading-[1.85] font-light" data-id="element-461">
            <p data-id="element-462">
              Muchos libros hablan de hábitos. Otros hablan de propósito. Otros
              hablan de emociones, espiritualidad o disciplina.
            </p>
            <p className="text-ivory/90" data-id="element-463">
              <span className="font-serif italic text-gold" data-id="element-464">
                La Estabilidad Dimensional de Nuestro Ser
              </span>{' '}
              une esas piezas en una sola visión.
            </p>
            <p data-id="element-465">
              Este libro entiende que una vida plena no se construye desde una
              sola área. Se construye cuando el cuerpo, la mente, las emociones,
              las relaciones, la intuición y la vocación comienzan a dialogar
              entre sí.
            </p>
            <p className="font-serif italic text-xl text-ivory/90 border-l border-gold/40 pl-5 leading-snug" data-id="element-466">
              No es un libro para leer rápido y olvidar. Es un libro para
              subrayar, pausar, reflexionar y volver a visitar cuando sientas
              que necesitas regresar a tu centro.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15} data-id="element-467">
          <Diagram data-id="element-468" />
        </Reveal>
      </div>
    </div>
  </section>;